
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'documents-public-ui',
  currentProjectVersion: 'static-1.34844',
  depVersions: {
  "documents-public-ui": "static-1.34844",
  "atom": "static-1.5211",
  "autolinker": "static-3.11",
  "avatar-components": "static-1.2634",
  "client-types": "static-1.486",
  "cssUtils": "static-1.833",
  "customer-data-filters-ui": "static-1.40276",
  "customer-data-objects": "static-1.7814",
  "customer-data-property-utils": "static-1.8231",
  "documents-lib": "static-1.34849",
  "emoji-mart": "static-3.4",
  "flux-actions": "static-1.349",
  "FormsCommonComponents": "static-1.86182",
  "FormUrlGenerator": "static-2.4858",
  "foundations-theming-specialty": "static-1.2287",
  "googlemaps-react-wrapper": "static-1.3",
  "head-dlb": "static-1.5007",
  "highcharts": "static-8.105",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.5730",
  "hs-test-utils": "static-1.8156",
  "hub-http": "static-1.6357",
  "hubspot-dlb": "static-2.1854",
  "HubStyle": "static-2.11914",
  "HubStyleTokens": "static-2.11607",
  "I18n": "static-7.1642",
  "icons": "static-2.657",
  "jasmine-immutable": "static-1.3157",
  "jasmine-runner": "static-1.6593",
  "js-cookie": "static-1.18",
  "laboratory-lib": "static-3.7288",
  "lodash": "static-1.3",
  "PatternValidationJS": "static-1.437",
  "pdf-js": "static-2.49",
  "property-translator": "static-1.5532",
  "quartz": "static-1.7213",
  "react": "static-7.187",
  "react-dlb": "static-1.81",
  "react-dnd": "static-3.19",
  "react-dnd-html5-backend": "static-3.7",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.71",
  "react-rhumb": "static-1.16822",
  "react-select-plus": "static-1.106",
  "react-utils": "static-2.5443",
  "react-virtualized": "static-2.100",
  "reference-resolvers": "static-1.8311",
  "reference-resolvers-lite": "static-1.8232",
  "reporting-data": "static-1.68107",
  "reporting-reports": "static-1.67785",
  "reporting-snowflake": "static-1.56725",
  "reporting-testing-lib": "static-1.10040",
  "reporting-visualizations": "static-1.60183",
  "reselect": "static-3.6",
  "sales-content-partitioning": "static-1.9084",
  "sanitize": "static-1.4612",
  "sanitize-text": "static-1.8282",
  "SharedI18nStrings": "static-1.182",
  "SharedLegalStrings": "static-1.1880",
  "signup-constants": "static-1.19197",
  "signup-ui-url-generator": "static-2.8194",
  "StyleGuideUI": "static-3.489",
  "superstore": "static-1.4896",
  "tinymce": "static-6.5",
  "transmute": "static-2.85",
  "ui-addon-draggable": "static-3.4896",
  "ui-addon-form-validation": "static-1.11127",
  "ui-asset-management-lib": "static-1.11212",
  "ui-images": "static-2.1191",
  "UIComponents": "static-3.8553",
  "usage-tracker": "static-1.7488",
  "usage-tracker-container": "static-1.7478",
  "usage-tracker-core": "static-1.7338",
  "viral-links-lib": "static-1.7206",
  "webpack-env": "static-1.54",
  "data-fetching-client": "static-1.9796",
  "foundations-components": "static-1.8206",
  "immutable": "static-2.79",
  "isMobile": "static-1.7",
  "PortalIdParser": "static-2.404",
  "quartz-config": "static-1.991",
  "quartz-core": "static-1.6432",
  "quick-fetch": "static-1.4020",
  "raven": "static-3.5925",
  "redux": "static-4.16",
  "redux-thunk": "static-2.43",
  "rpc-client-utils": "static-1.4792",
  "ui-addon-i18n": "static-1.11284",
  "ui-addon-upgrades": "static-9.18178",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "hubspot-url-utils": "static-1.4132",
  "metrics-js": "static-1.9637",
  "styled-components": "static-2.89",
  "bend-plugin-trellis-migration": "static-1.3503",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3490",
  "quartz-webpack": "static-1.3437",
  "foundations-assets": "static-1.5010",
  "foundations-theming": "static-1.4571",
  "hub-http-shared-msw-handlers": "static-1.10300",
  "hubspotter-http": "static-1.4753",
  "sassPrefix": "static-1.158",
  "conversations-skeleton-state": "static-1.7383",
  "crm-message-bus": "static-1.43347",
  "customer-data-filters-ui-msw-helpers": "static-1.22711",
  "customer-data-objects-ui-components": "static-1.13165",
  "customer-data-reference-ui-components": "static-1.13311",
  "customer-data-ui-utilities": "static-1.9960",
  "events-data-lib": "static-1.371",
  "framework-builder-read-service-client": "static-1.4108",
  "framework-data-schema-quick-fetch": "static-1.6934",
  "framework-data-schema-resolvers": "static-1.7029",
  "immer": "static-1.33",
  "inbound-db-meta-service-client": "static-1.3690",
  "inbound-db-properties-service-client": "static-1.3949",
  "multi-account-reference-resolvers": "static-1.1117",
  "onboarding-tours": "static-1.16866",
  "reporting-datasets-permissions-lib": "static-1.14068",
  "stylex": "static-1.35",
  "trellis-assets": "static-1.2222",
  "trellis-components": "static-1.2241",
  "trellis-theming": "static-1.1079",
  "ui-addon-teams": "static-1.21726",
  "quartz-auth": "static-1.888",
  "ui-business-units-lib": "static-1.9205",
  "usage-tracker-session-replay": "static-1.5174",
  "ai-components-ui-library": "static-1.9293",
  "ContentUtils": "static-1.68761",
  "customer-data-properties": "static-1.52018",
  "forms-ai-lib": "static-1.4536",
  "forms-utils-lib": "static-1.12843",
  "foundations-components-test-utils": "static-1.5689",
  "react-dnd-compat": "static-1.4750",
  "react-tinymce": "static-1.55603",
  "tinymce-config": "static-2.54729",
  "ui-gdpr-components": "static-1.10488",
  "underscore": "static-1.8",
  "foundations-theming-base": "static-1.3556",
  "HeadJS": "static-2.774",
  "framer-motion": "static-1.73",
  "hs-test-utils-bend-plugin": "static-1.3267",
  "msw": "static-1.39",
  "testing-library": "static-1.153",
  "hs-locale-management": "static-1.184",
  "ui-fonts": "static-1.869",
  "i18n-data": "static-1.224",
  "moment-timezone": "static-5.84",
  "jasmine": "static-4.4461",
  "csstype": "static-1.50",
  "quartz-head": "static-1.878",
  "web-vitals": "static-1.7",
  "batch-promise": "static-1.1680",
  "external-options-client-types": "static-1.4229",
  "fast-json-stable-stringify": "static-1.4",
  "quartz-i18n": "static-1.888",
  "frontend-preferences-client": "static-1.8062",
  "graphql": "static-1.83",
  "persist-promise": "static-1.3837",
  "reporting-client-types": "static-1.2582",
  "apollo-stack-hubspot": "static-3.87",
  "growth-payments-core": "static-1.25776",
  "hubspot-apollo-client": "static-1.5013",
  "foundations-components-legacy": "static-1.1231",
  "quartz-routing": "static-1.643",
  "hs-story-utils": "static-1.9559",
  "react-flip-move": "static-1.72",
  "nested-table": "static-1.374",
  "timezone-utils": "static-2.5379",
  "seat-types-lib": "static-1.311",
  "react-create-root-preference": "static-1.41",
  "bend-plugin-foundations-components": "static-1.4475",
  "floating-ui": "static-1.58",
  "react-aria": "static-1.67",
  "tanstack-table": "static-1.56",
  "dispatcher": "static-1.139",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.850",
  "mobile-manifest-mixins": "static-1.548",
  "module-federation": "static-1.27",
  "quartz-test": "static-1.888",
  "quartz-tracking": "static-1.592",
  "bend-plugin-chirp-manifest": "static-1.202",
  "chirp-fetch": "static-1.2023",
  "merchandise-lib": "static-1.266",
  "purchase-motions-components": "static-1.6120",
  "salesImages": "static-1.527",
  "ts-schema": "static-1.4184",
  "bender-build-tools": "static-1.3301",
  "bend-plugin-foundations-theming": "static-1.3054",
  "restore-request-side-panel-lib": "static-1.1235",
  "react-immutable-render-mixin": "static-1.9",
  "hs-resources": "static-1.314",
  "pulse": "static-1.740",
  "conditional-properties-service-client": "static-1.3900",
  "crm-pipelines-api-client-types": "static-1.4240",
  "fdsr-migration-layer": "static-1.148",
  "multi-currency-client-types": "static-1.3794",
  "getting-started-shared-tasks": "static-1.18791",
  "growth-data-modal": "static-1.5656",
  "growth-onboarding-confetti": "static-1.3201",
  "growth-onboarding-next-action-utils": "static-1.2306",
  "navigation-components": "static-1.18332",
  "onboarding-tours-client": "static-1.5080",
  "onboarding-tours-utils": "static-1.932",
  "ui-shepherd-react": "static-3.10393",
  "ui-shepherd-tracker": "static-1.7774",
  "ui-universal-auth": "static-1.9142",
  "user-context": "static-1.5244",
  "base-ui": "static-1.15",
  "react-day-picker": "static-1.4",
  "tanstack-virtual": "static-1.31",
  "hubspotter-http-shared-msw-handlers": "static-1.10298",
  "magpie-lib": "static-1.5642",
  "navigation-messaging": "static-1.7659",
  "amplitude-session-replay-browser": "static-1.60",
  "chatspot-core": "static-1.21963",
  "copilot-toolkit": "static-1.11483",
  "cms-field-types": "static-1.4950",
  "content-icons-ui": "static-1.2268",
  "integrations-lib": "static-1.16582",
  "calling-global-api": "static-1.64953",
  "calling-internal-common": "static-1.31448",
  "calling-lifecycle-internal": "static-1.66335",
  "calling-lifecycle-messages": "static-1.58629",
  "commerce-products-lib": "static-1.10068",
  "crm-links": "static-1.6444",
  "customer-data-properties-shared-msw-handlers": "static-1.9627",
  "file-manager-components": "static-1.24024",
  "google-libphonenumber": "static-1.39",
  "inbounddb-objects-service-types": "static-1.4320",
  "meetings-icalendar-utils-lib": "static-1.769",
  "object-builder-ui-client": "static-1.49215",
  "pipeline-validation-client-types": "static-1.4069",
  "property-value-citations": "static-1.2632",
  "smart-property-lib": "static-1.7959",
  "tiered-pricing": "static-1.1580",
  "topics-actions-lib": "static-1.227",
  "ui-addon-iframeable": "static-1.9204",
  "zustand": "static-1.74",
  "final-form": "static-1.71",
  "redux-mock-store": "static-1.8",
  "redux-toolkit": "static-1.7",
  "rich-text-lib": "static-1.20070",
  "tinymce-themes": "static-1.56699",
  "data-token-picker": "static-1.16650",
  "hub-http-contrib": "static-1.3179",
  "interframe": "static-3.4894",
  "tinymce-data": "static-1.40814",
  "tinymce-plugins": "static-1.57843",
  "ui-addon-sales-email": "static-1.5346",
  "onboarding-scopes": "static-1.6596",
  "ui-addon-opt": "static-4.8497",
  "apollo-link-hub-http": "static-2.4787",
  "hubspot-apollo-cache": "static-1.472",
  "react-window": "static-1.13",
  "ts-utils-lib": "static-1.310",
  "purchase-motions-api": "static-1.6123",
  "event-emitter": "static-1.1085",
  "bend-plugin-pulse": "static-1.243",
  "fast-json-patch": "static-1.64",
  "onboarding-data-sync-lib": "static-1.2206",
  "growth-onboarding-next-action-components": "static-1.2334",
  "user-context-client": "static-1.4714",
  "idb-keyval": "static-1.45",
  "magpie-types": "static-1.5102",
  "nest": "static-1.369",
  "reactive-lib": "static-1.861",
  "simple-logging-lib": "static-1.3184",
  "unified-auth-core-lib": "static-1.938",
  "getting-started-shared-tasks-store": "static-1.17909",
  "markdown-it": "static-1.6",
  "breeze-engine-lib": "static-1.1187",
  "integrations-error-boundary-lib": "static-1.13997",
  "integrations-tracking-lib": "static-1.5743",
  "native-integrations-shared-strings": "static-1.7916",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10498",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.656",
  "calling-error-reporting": "static-1.31455",
  "shared-worker-versioning": "static-1.11171",
  "calling-usage-tracker": "static-1.6678",
  "voice-sms-access-library": "static-1.1496",
  "customer-data-tracking": "static-1.7022",
  "commerce-permissions": "static-1.910",
  "products-iframe-lib": "static-1.8305",
  "products-ui-components-shared-msw-handlers": "static-1.10682",
  "location-customization-utils-lib": "static-1.9646",
  "apollo-dlb": "static-3.86",
  "immerable": "static-1.4286",
  "video-components-external": "static-1.11733",
  "video-data-lib": "static-1.35391",
  "data-agent-kit": "static-1.424",
  "feedback-loader": "static-1.29553",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10383",
  "fsm": "static-1.3866",
  "policy-lib": "static-1.6922",
  "react-colorpicker": "static-2.10343",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10446",
  "FileManagerLib": "static-1.39664",
  "NamespacedHubStyle": "static-2.9156",
  "FileManagerCore": "static-1.39523",
  "codemirror": "static-5.96",
  "content-assistance-lib": "static-1.7973",
  "layout-dnd-components": "static-1.12714",
  "layout-dnd-utils": "static-1.11689",
  "react-codemirror": "static-1.10763",
  "ui-addon-emoji-picker": "static-1.10020",
  "ui-brand-identity-lib": "static-1.15774",
  "InboxConnectUtils": "static-4.15180",
  "meetings-connect-utils-lib": "static-1.7742",
  "breeze-engine-core": "static-1.465",
  "ably": "static-2.2",
  "highlight.js": "static-1.80",
  "universal-page-editor-lib": "static-1.3147",
  "adobe-sign-auth-lib": "static-1.73",
  "ads-unified-auth-lib": "static-1.504",
  "google-sheets-integration-lib": "static-1.635",
  "microsoft-drive-integration-lib": "static-1.798",
  "surveymonkey-integration-lib": "static-1.92",
  "slack-ui-library": "static-1.10534",
  "calling-orchestration-schema": "static-1.36273",
  "sales-views-client-types": "static-1.4393",
  "crm-record-cards-service-types": "static-1.3689",
  "content-media-composition-data-lib": "static-1.12742",
  "content-media-compositions": "static-2.16749",
  "media-bridge-lib": "static-1.19167",
  "trellis-story-utils": "static-1.4645",
  "storybook-react": "static-1.34",
  "audio-components": "static-1.6129",
  "FileManagerImages": "static-1.37175",
  "video-components": "static-1.13735",
  "cropperjs": "static-1.10",
  "html-to-image": "static-1.55",
  "urlinator": "static-1.4671",
  "video-embed": "static-1.36225",
  "diff-match-patch": "static-1.7",
  "ui-addon-video-player": "static-1.8841",
  "ui-coaching-tips": "static-1.28937",
  "ContentData": "static-1.68836",
  "layout-data-lib": "static-1.10014",
  "browser-eslint": "static-2.57",
  "social-insights-client-types": "static-1.22408",
  "outpost": "static-1.4305",
  "growth-onboarding-feedback-components": "static-1.6715",
  "advanced-menus-core": "static-1.15359",
  "advanced-menus-lib": "static-1.12267",
  "ExportDialog": "static-6.10515",
  "ui-memberships-settings-lib": "static-1.34412",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15358",
  "simple-menus-lib": "static-1.16875"
},
  depPathPrefixes: {
  "documents-public-ui": "/documents-public-ui/static-1.34844",
  "atom": "/atom/static-1.5211",
  "autolinker": "/autolinker/static-3.11",
  "avatar-components": "/avatar-components/static-1.2634",
  "client-types": "/client-types/static-1.486",
  "cssUtils": "/cssUtils/static-1.833",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.40276",
  "customer-data-objects": "/customer-data-objects/static-1.7814",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8231",
  "documents-lib": "/documents-lib/static-1.34849",
  "emoji-mart": "/emoji-mart/static-3.4",
  "flux-actions": "/flux-actions/static-1.349",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.86182",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4858",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2287",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "head-dlb": "/head-dlb/static-1.5007",
  "highcharts": "/highcharts/static-8.105",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.5730",
  "hs-test-utils": "/hs-test-utils/static-1.8156",
  "hub-http": "/hub-http/static-1.6357",
  "hubspot-dlb": "/hubspot-dlb/static-2.1854",
  "HubStyle": "/HubStyle/static-2.11914",
  "HubStyleTokens": "/HubStyleTokens/static-2.11607",
  "I18n": "/I18n/static-7.1642",
  "icons": "/icons/static-2.657",
  "jasmine-immutable": "/jasmine-immutable/static-1.3157",
  "jasmine-runner": "/jasmine-runner/static-1.6593",
  "js-cookie": "/js-cookie/static-1.18",
  "laboratory-lib": "/laboratory-lib/static-3.7288",
  "lodash": "/lodash/static-1.3",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "pdf-js": "/pdf-js/static-2.49",
  "property-translator": "/property-translator/static-1.5532",
  "quartz": "/quartz/static-1.7213",
  "react": "/react/static-7.187",
  "react-dlb": "/react-dlb/static-1.81",
  "react-dnd": "/react-dnd/static-3.19",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-3.7",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.71",
  "react-rhumb": "/react-rhumb/static-1.16822",
  "react-select-plus": "/react-select-plus/static-1.106",
  "react-utils": "/react-utils/static-2.5443",
  "react-virtualized": "/react-virtualized/static-2.100",
  "reference-resolvers": "/reference-resolvers/static-1.8311",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8232",
  "reporting-data": "/reporting-data/static-1.68107",
  "reporting-reports": "/reporting-reports/static-1.67785",
  "reporting-snowflake": "/reporting-snowflake/static-1.56725",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.10040",
  "reporting-visualizations": "/reporting-visualizations/static-1.60183",
  "reselect": "/reselect/static-3.6",
  "sales-content-partitioning": "/sales-content-partitioning/static-1.9084",
  "sanitize": "/sanitize/static-1.4612",
  "sanitize-text": "/sanitize-text/static-1.8282",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1880",
  "signup-constants": "/signup-constants/static-1.19197",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8194",
  "StyleGuideUI": "/StyleGuideUI/static-3.489",
  "superstore": "/superstore/static-1.4896",
  "tinymce": "/tinymce/static-6.5",
  "transmute": "/transmute/static-2.85",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4896",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11127",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11212",
  "ui-images": "/ui-images/static-2.1191",
  "UIComponents": "/UIComponents/static-3.8553",
  "usage-tracker": "/usage-tracker/static-1.7488",
  "usage-tracker-container": "/usage-tracker-container/static-1.7478",
  "usage-tracker-core": "/usage-tracker-core/static-1.7338",
  "viral-links-lib": "/viral-links-lib/static-1.7206",
  "webpack-env": "/webpack-env/static-1.54",
  "data-fetching-client": "/data-fetching-client/static-1.9796",
  "foundations-components": "/foundations-components/static-1.8206",
  "immutable": "/immutable/static-2.79",
  "isMobile": "/isMobile/static-1.7",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "quartz-config": "/quartz-config/static-1.991",
  "quartz-core": "/quartz-core/static-1.6432",
  "quick-fetch": "/quick-fetch/static-1.4020",
  "raven": "/raven/static-3.5925",
  "redux": "/redux/static-4.16",
  "redux-thunk": "/redux-thunk/static-2.43",
  "rpc-client-utils": "/rpc-client-utils/static-1.4792",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11284",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18178",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4132",
  "metrics-js": "/metrics-js/static-1.9637",
  "styled-components": "/styled-components/static-2.89",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3503",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3490",
  "quartz-webpack": "/quartz-webpack/static-1.3437",
  "foundations-assets": "/foundations-assets/static-1.5010",
  "foundations-theming": "/foundations-theming/static-1.4571",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10300",
  "hubspotter-http": "/hubspotter-http/static-1.4753",
  "sassPrefix": "/sassPrefix/static-1.158",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7383",
  "crm-message-bus": "/crm-message-bus/static-1.43347",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.22711",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13165",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13311",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9960",
  "events-data-lib": "/events-data-lib/static-1.371",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4108",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6934",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7029",
  "immer": "/immer/static-1.33",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3690",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3949",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1117",
  "onboarding-tours": "/onboarding-tours/static-1.16866",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.14068",
  "stylex": "/stylex/static-1.35",
  "trellis-assets": "/trellis-assets/static-1.2222",
  "trellis-components": "/trellis-components/static-1.2241",
  "trellis-theming": "/trellis-theming/static-1.1079",
  "ui-addon-teams": "/ui-addon-teams/static-1.21726",
  "quartz-auth": "/quartz-auth/static-1.888",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9205",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5174",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9293",
  "ContentUtils": "/ContentUtils/static-1.68761",
  "customer-data-properties": "/customer-data-properties/static-1.52018",
  "forms-ai-lib": "/forms-ai-lib/static-1.4536",
  "forms-utils-lib": "/forms-utils-lib/static-1.12843",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5689",
  "react-dnd-compat": "/react-dnd-compat/static-1.4750",
  "react-tinymce": "/react-tinymce/static-1.55603",
  "tinymce-config": "/tinymce-config/static-2.54729",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10488",
  "underscore": "/underscore/static-1.8",
  "foundations-theming-base": "/foundations-theming-base/static-1.3556",
  "HeadJS": "/HeadJS/static-2.774",
  "framer-motion": "/framer-motion/static-1.73",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3267",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.153",
  "hs-locale-management": "/hs-locale-management/static-1.184",
  "ui-fonts": "/ui-fonts/static-1.869",
  "i18n-data": "/i18n-data/static-1.224",
  "moment-timezone": "/moment-timezone/static-5.84",
  "jasmine": "/jasmine/static-4.4461",
  "csstype": "/csstype/static-1.50",
  "quartz-head": "/quartz-head/static-1.878",
  "web-vitals": "/web-vitals/static-1.7",
  "batch-promise": "/batch-promise/static-1.1680",
  "external-options-client-types": "/external-options-client-types/static-1.4229",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "quartz-i18n": "/quartz-i18n/static-1.888",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8062",
  "graphql": "/graphql/static-1.83",
  "persist-promise": "/persist-promise/static-1.3837",
  "reporting-client-types": "/reporting-client-types/static-1.2582",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.87",
  "growth-payments-core": "/growth-payments-core/static-1.25776",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5013",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1231",
  "quartz-routing": "/quartz-routing/static-1.643",
  "hs-story-utils": "/hs-story-utils/static-1.9559",
  "react-flip-move": "/react-flip-move/static-1.72",
  "nested-table": "/nested-table/static-1.374",
  "timezone-utils": "/timezone-utils/static-2.5379",
  "seat-types-lib": "/seat-types-lib/static-1.311",
  "react-create-root-preference": "/react-create-root-preference/static-1.41",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4475",
  "floating-ui": "/floating-ui/static-1.58",
  "react-aria": "/react-aria/static-1.67",
  "tanstack-table": "/tanstack-table/static-1.56",
  "dispatcher": "/dispatcher/static-1.139",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.850",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.548",
  "module-federation": "/module-federation/static-1.27",
  "quartz-test": "/quartz-test/static-1.888",
  "quartz-tracking": "/quartz-tracking/static-1.592",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.202",
  "chirp-fetch": "/chirp-fetch/static-1.2023",
  "merchandise-lib": "/merchandise-lib/static-1.266",
  "purchase-motions-components": "/purchase-motions-components/static-1.6120",
  "salesImages": "/salesImages/static-1.527",
  "ts-schema": "/ts-schema/static-1.4184",
  "bender-build-tools": "/bender-build-tools/static-1.3301",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3054",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1235",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "hs-resources": "/hs-resources/static-1.314",
  "pulse": "/pulse/static-1.740",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3900",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4240",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.148",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3794",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18791",
  "growth-data-modal": "/growth-data-modal/static-1.5656",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3201",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2306",
  "navigation-components": "/navigation-components/static-1.18332",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5080",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.932",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10393",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7774",
  "ui-universal-auth": "/ui-universal-auth/static-1.9142",
  "user-context": "/user-context/static-1.5244",
  "base-ui": "/base-ui/static-1.15",
  "react-day-picker": "/react-day-picker/static-1.4",
  "tanstack-virtual": "/tanstack-virtual/static-1.31",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10298",
  "magpie-lib": "/magpie-lib/static-1.5642",
  "navigation-messaging": "/navigation-messaging/static-1.7659",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "chatspot-core": "/chatspot-core/static-1.21963",
  "copilot-toolkit": "/copilot-toolkit/static-1.11483",
  "cms-field-types": "/cms-field-types/static-1.4950",
  "content-icons-ui": "/content-icons-ui/static-1.2268",
  "integrations-lib": "/integrations-lib/static-1.16582",
  "calling-global-api": "/calling-global-api/static-1.64953",
  "calling-internal-common": "/calling-internal-common/static-1.31448",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.66335",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.58629",
  "commerce-products-lib": "/commerce-products-lib/static-1.10068",
  "crm-links": "/crm-links/static-1.6444",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9627",
  "file-manager-components": "/file-manager-components/static-1.24024",
  "google-libphonenumber": "/google-libphonenumber/static-1.39",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4320",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.769",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49215",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4069",
  "property-value-citations": "/property-value-citations/static-1.2632",
  "smart-property-lib": "/smart-property-lib/static-1.7959",
  "tiered-pricing": "/tiered-pricing/static-1.1580",
  "topics-actions-lib": "/topics-actions-lib/static-1.227",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9204",
  "zustand": "/zustand/static-1.74",
  "final-form": "/final-form/static-1.71",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "rich-text-lib": "/rich-text-lib/static-1.20070",
  "tinymce-themes": "/tinymce-themes/static-1.56699",
  "data-token-picker": "/data-token-picker/static-1.16650",
  "hub-http-contrib": "/hub-http-contrib/static-1.3179",
  "interframe": "/interframe/static-3.4894",
  "tinymce-data": "/tinymce-data/static-1.40814",
  "tinymce-plugins": "/tinymce-plugins/static-1.57843",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5346",
  "onboarding-scopes": "/onboarding-scopes/static-1.6596",
  "ui-addon-opt": "/ui-addon-opt/static-4.8497",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4787",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.472",
  "react-window": "/react-window/static-1.13",
  "ts-utils-lib": "/ts-utils-lib/static-1.310",
  "purchase-motions-api": "/purchase-motions-api/static-1.6123",
  "event-emitter": "/event-emitter/static-1.1085",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.243",
  "fast-json-patch": "/fast-json-patch/static-1.64",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2206",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2334",
  "user-context-client": "/user-context-client/static-1.4714",
  "idb-keyval": "/idb-keyval/static-1.45",
  "magpie-types": "/magpie-types/static-1.5102",
  "nest": "/nest/static-1.369",
  "reactive-lib": "/reactive-lib/static-1.861",
  "simple-logging-lib": "/simple-logging-lib/static-1.3184",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.938",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17909",
  "markdown-it": "/markdown-it/static-1.6",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1187",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13997",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5743",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7916",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10498",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.656",
  "calling-error-reporting": "/calling-error-reporting/static-1.31455",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11171",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6678",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.1496",
  "customer-data-tracking": "/customer-data-tracking/static-1.7022",
  "commerce-permissions": "/commerce-permissions/static-1.910",
  "products-iframe-lib": "/products-iframe-lib/static-1.8305",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10682",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9646",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "immerable": "/immerable/static-1.4286",
  "video-components-external": "/video-components-external/static-1.11733",
  "video-data-lib": "/video-data-lib/static-1.35391",
  "data-agent-kit": "/data-agent-kit/static-1.424",
  "feedback-loader": "/feedback-loader/static-1.29553",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10383",
  "fsm": "/fsm/static-1.3866",
  "policy-lib": "/policy-lib/static-1.6922",
  "react-colorpicker": "/react-colorpicker/static-2.10343",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10446",
  "FileManagerLib": "/FileManagerLib/static-1.39664",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9156",
  "FileManagerCore": "/FileManagerCore/static-1.39523",
  "codemirror": "/codemirror/static-5.96",
  "content-assistance-lib": "/content-assistance-lib/static-1.7973",
  "layout-dnd-components": "/layout-dnd-components/static-1.12714",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11689",
  "react-codemirror": "/react-codemirror/static-1.10763",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10020",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15774",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15180",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7742",
  "breeze-engine-core": "/breeze-engine-core/static-1.465",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.80",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3147",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.73",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.504",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.635",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.798",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.92",
  "slack-ui-library": "/slack-ui-library/static-1.10534",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.36273",
  "sales-views-client-types": "/sales-views-client-types/static-1.4393",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3689",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12742",
  "content-media-compositions": "/content-media-compositions/static-2.16749",
  "media-bridge-lib": "/media-bridge-lib/static-1.19167",
  "trellis-story-utils": "/trellis-story-utils/static-1.4645",
  "storybook-react": "/storybook-react/static-1.34",
  "audio-components": "/audio-components/static-1.6129",
  "FileManagerImages": "/FileManagerImages/static-1.37175",
  "video-components": "/video-components/static-1.13735",
  "cropperjs": "/cropperjs/static-1.10",
  "html-to-image": "/html-to-image/static-1.55",
  "urlinator": "/urlinator/static-1.4671",
  "video-embed": "/video-embed/static-1.36225",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8841",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28937",
  "ContentData": "/ContentData/static-1.68836",
  "layout-data-lib": "/layout-data-lib/static-1.10014",
  "browser-eslint": "/browser-eslint/static-2.57",
  "social-insights-client-types": "/social-insights-client-types/static-1.22408",
  "outpost": "/outpost/static-1.4305",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6715",
  "advanced-menus-core": "/advanced-menus-core/static-1.15359",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12267",
  "ExportDialog": "/ExportDialog/static-6.10515",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34412",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15358",
  "simple-menus-lib": "/simple-menus-lib/static-1.16875"
}
};
